/* eslint-disable prettier/prettier */
import "./style.css"

const Wasteland = () => {
    return   
}

export default Wasteland
